import { useEffect, useRef } from 'react';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import EditComponent from './GiftCardPlansApplicablesMembershipTypeEdit';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';

const WebComponent = (props: any) => {
    const title = '礼品卡方案适合会员类型';
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;

    useEffect(() => {

    }, []);

    //表头
    const columnsHead = [
        {
            title: '会员类型',
            dataIndex: 'membershipType',
            render: (val: any) => val?.typeName
        },
        {
            title: '礼品卡方案',
            dataIndex: 'giftCardPlans',
            render: (val: any) => val?.planName
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: title,
        apiId: 'giftCardPlansApplicablesMembershipType',
        columns,
        EditComponent,
        serviceId: 'business',
        sendPageData: data,
        showStates: true
    };

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={800} >
                <WebUniversal props={extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
